import React from "react";
import { withRouteData } from "react-static";

import Project from "./project";

export default withRouteData(({ projects, project }) => (
  <div>
    <Project project={project} projects={projects} />
  </div>
));
